import { useCallback, useEffect, useState } from 'react';
var SKIPPING_INTERVAL = 10;
export function useAudioTime(audioRef) {
  var _useState = useState(0),
      currentTime = _useState[0],
      setCurrentTime = _useState[1];

  var seek = useCallback(function (time) {
    audioRef.current.currentTime = time;
    setCurrentTime(time);
  }, [audioRef, setCurrentTime]);
  var fastForward = useCallback(function () {
    seek(audioRef.current.currentTime + SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  var rewind = useCallback(function () {
    seek(audioRef.current.currentTime - SKIPPING_INTERVAL);
  }, [audioRef, seek]);
  useOnTimeUpdateEvent(audioRef, setCurrentTime);
  return {
    currentTime: currentTime,
    seek: seek,
    fastForward: fastForward,
    rewind: rewind
  };
}
/**
 * The hook responsible for registering the given callback to the "TimeUpdate" event of the audio.
 * @param audioRef
 * @param setTime
 */

function useOnTimeUpdateEvent(audioRef, setTime) {
  useEffect(function () {
    var audioElem = audioRef.current;

    var handleOnTimeUpdate = function handleOnTimeUpdate() {
      setTime(audioElem.currentTime);
    };

    audioElem.addEventListener('timeupdate', handleOnTimeUpdate);
    return function () {
      audioElem.removeEventListener('timeupdate', handleOnTimeUpdate);
    };
  }, [audioRef, setTime]);
}